import classNames from 'classnames';
import React from 'react';

import BenchlingIcon, {BenchlingIconProps} from 'ui-library/icons/BenchlingIcon';

type WarningIconProps = Omit<BenchlingIconProps, 'icon'>;

const WarningIcon = React.forwardRef<SVGSVGElement, WarningIconProps>(
  (props: WarningIconProps, ref): JSX.Element => (
    <BenchlingIcon
      icon="warning"
      {...props}
      className={classNames('u-dark-warning-color', props.className)}
      ref={ref}
    />
  )
);

export default WarningIcon;
